module.exports = __webpack_public_path__ + "img/rcs_with_beak.91cef4aa.svg";